import styled, { css } from 'styled-components';
import { mq } from 'stylesheets/utils';

export const ProductsWithFiltersWrapper = styled.div``;
export const CategoriesWrpper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const CategoriesRow = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 22px;
  overflow-x: auto;
`;
export const ProductsListWrapper = styled.div<{ readonly fullHeight?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 740px;
  max-height: 740px;
  overflow-y: auto;
  padding: 0 10px 20px 10px;
  max-width: 780px;
  margin-bottom: 24px;
  justify-content: center;
  ${mq(992)} {
    margin-top: 24px;
    justify-content: center;
  }
  ${mq(576)} {
    padding: 10px 0;
    justify-content: initial;
    gap: 10px;
  }
  ${({ fullHeight }) =>
    fullHeight &&
    css`
      min-height: auto;
      max-height: none;
      max-width: none;
      overflow: initial;
      background-color: ${({ theme }) => theme.colors.filterCardBg};
      padding: 24px 12px;
    `}
`;
export const CarProductsWrapper = styled.div`
  margin: 24px 0 48px;
`;
export const ImageWrapper = styled.div`
  text-align: center;
  width: 340px;
  height: 200px;
  position: relative;
  margin: 0 auto 12px auto;
`;
export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  z-index: 6;
  ${mq(576)} {
    flex-direction: column;
  }
`;
